import React from 'react';

interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  className?: string;
}

export const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  onClick,
  type = 'button',
  disabled = false,
  className = '',
}) => {
  const baseStyles = 'whitespace-nowrap cursor-pointer font-medium transition-all duration-300 ease-in-out';
  
  const variantStyles = {
    primary: 'bg-[#D4AF37] text-[#0A1628] hover:bg-[#C19B2A] hover:scale-[1.02] hover:shadow-lg',
    secondary: 'bg-[#0A1628] text-white hover:bg-[#152238] hover:scale-[1.02] hover:shadow-lg',
    outline: 'bg-transparent border-2 border-white text-white hover:bg-white hover:text-[#0A1628]',
    ghost: 'bg-transparent text-[#D4AF37] hover:bg-[#D4AF37]/10',
  };
  
  const sizeStyles = {
    sm: 'px-6 py-2 text-sm rounded-full',
    md: 'px-8 py-3 text-base rounded-full',
    lg: 'px-12 py-4 text-lg rounded-full',
  };
  
  const widthStyle = fullWidth ? 'w-full' : '';
  
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${widthStyle} ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}
    >
      {children}
    </button>
  );
};